import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import NotFound from "pages/NotFound";
import BotCreationWizard from './pages/bot-creation-wizard';
import PaperTrading from './pages/paper-trading';
import BotDetails from './pages/bot-details';
import BotAnalytics from './pages/bot-analytics';
import BacktestingEngine from './pages/backtesting-engine';
import BotMarketplace from './pages/bot-marketplace';
import Login from "pages/Auth/Login";
import MainLayout from "layouts/MainLayout";
import ProtectedRoutes from "routes/ProtectedRoutes";
import Register from "pages/Auth/Register";
import ApiCredentials from "pages/ApiKey/ApiCredentials";
import ConnectExchangeUI from "components/APIKey/ConnectExchangeUI";
import ExchangeDetailUI from "components/APIKey/ExchangeDetailUI";
import LiveForm from "components/APIKey/LiveForm";
import PaperForm from "components/APIKey/PaperForm";
import MainProfile from "pages/Profile/MainProfile";
import MainSubscription from "pages/Subscription/MainSubscription";
import Calculator from "pages/calculator";

const Routes = () => {
  return (
    <BrowserRouter>

      <ScrollToTop />
      <RouterRoutes>

        {/* //unsafe route */}
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* // protected routes  */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoutes>
              <MainLayout />
            </ProtectedRoutes>
          }
        >

          <Route index element={<BacktestingEngine />} />
          <Route path="bot-creation-wizard" element={<BotCreationWizard />} />
          <Route path="paper-trading" element={<PaperTrading />} />
          <Route path="bot-details" element={<BotDetails />} />
          <Route path="bot-analytics" element={<BotAnalytics />} />
          <Route path="backtesting-engine" element={<BacktestingEngine />} />
          {/* <Route path="bot-marketplace" element={<BotMarketplace />} /> */}
          <Route path="api" element={<ApiCredentials />} />
          <Route path="subscription" element={<MainSubscription />} />
          <Route path="connect-exchange" element={<ConnectExchangeUI />} />
          <Route path="calculator" element={<Calculator />} />
          <Route path="connect/:exchange/:mode" element={<ExchangeDetailUI />}>
            <Route path="live" element={<LiveForm />} />
            <Route path="paper" element={<PaperForm />} />
          </Route>
          <Route path="profile" element={<MainProfile />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>

    </BrowserRouter>
  );
};

export default Routes;



